<swiper-container #swiperContainer [id]="swiperId" [navigation]="navigation" autoplay="true" init="false"
                  pagination="true">
  <ng-content></ng-content>
</swiper-container>
